import React from 'react';
import { Col, Form, InputNumber, Row, Switch } from 'antd';

const DEFAULT_REPLY_DELAY = {
  enabled: false,
  base_seconds: 1.5,
  per_char_ms: 35,
  jitter: 0.25,
  min_seconds: 1,
  max_seconds: 15,
};

export { DEFAULT_REPLY_DELAY };

export default function BotReplyDelayFields() {
  return (
    <>
      <Form.Item
        name={['reply_delay', 'enabled']}
        label="Human-like reply delay"
        valuePropName="checked"
        extra="Wait before sending so replies feel less instant. Shows typing while waiting."
      >
        <Switch />
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(prev, cur) => prev.reply_delay?.enabled !== cur.reply_delay?.enabled}
      >
        {({ getFieldValue }) => {
          if (!getFieldValue(['reply_delay', 'enabled'])) return null;
          return (
            <Row gutter={12}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  name={['reply_delay', 'base_seconds']}
                  label="Base pause (sec)"
                  extra="Fixed thinking time before typing"
                >
                  <InputNumber min={0} max={30} step={0.5} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  name={['reply_delay', 'per_char_ms']}
                  label="Per character (ms)"
                  extra="Extra time scaled by reply length"
                >
                  <InputNumber min={0} max={200} step={5} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  name={['reply_delay', 'jitter']}
                  label="Jitter"
                  extra="Random variance (0–0.5 = ±0–50%)"
                >
                  <InputNumber min={0} max={0.5} step={0.05} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name={['reply_delay', 'min_seconds']} label="Min delay (sec)">
                  <InputNumber min={0} max={60} step={0.5} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name={['reply_delay', 'max_seconds']} label="Max delay (sec)">
                  <InputNumber min={1} max={120} step={1} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          );
        }}
      </Form.Item>
    </>
  );
}
